document.querySelectorAll('.product__media-wrapper slider-component.slider-mobile-gutter').forEach((sliderComponent) => {
  const fill = sliderComponent.querySelector('.product__media-progress-fill');
  const track = sliderComponent.querySelector('[id^="Slider-"]');
  if (!fill || !track) return;

  function update() {
    const maxScroll = track.scrollWidth - track.clientWidth;
    const percent = maxScroll > 0 ? (track.scrollLeft / maxScroll) * 100 : 100;
    fill.style.width = `${Math.max(8, percent)}%`;
  }

  track.addEventListener('scroll', update, { passive: true });
  update();
});
